var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "directory-detail clearfix" },
    [
      _c(
        "TMSHeader",
        { attrs: { title: _vm.title, fullScreen: true } },
        [
          _c(
            "div",
            {
              class: _vm.pointerClass,
              attrs: { slot: "status" },
              on: { click: _vm.openLifecycleFun },
              slot: "status",
            },
            [_c("TheDirStatusHeader")],
            1
          ),
          _vm._v(" "),
          _c("template", { slot: "before-buttons" }, [
            _vm.canEdit
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn--darkblue",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.edit()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.edit")))]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.canEditPublished
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn--darkblue",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.action(_vm.ACTION.editPublished)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("action.edit")))]
                )
              : _vm._e(),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "Modal",
        { ref: "alertActionMsg", attrs: { modalId: "dir-alert-" + _vm.id } },
        [
          _c(
            "div",
            {
              staticClass: "font-bold",
              attrs: { slot: "content" },
              slot: "content",
            },
            [_c("div", { domProps: { innerHTML: _vm._s(_vm.alertMsg) } })]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange close-reveal-modal",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.doIt()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.yesContinue")))]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.isEngineer
        ? _c("Lifecycle", {
            ref: "directoryLifecycle",
            attrs: {
              modalId: "directory-modules-lifecycle-modal",
              type: "directory",
              commentAttr: _vm.lifecycleCommentAttrs.comments,
              histories: _vm.histories,
              allowPreformattedComments: true,
              emptyHistoryHint: _vm.emptyHistoryHint,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "directory-detail__info clearfix" },
        [
          _c("div", { staticClass: "effective--date-reject-history" }, [
            _c(
              "div",
              {
                class: [
                  _vm.isFloorDR
                    ? "floor-effective-remove-date"
                    : "effective-remove-date",
                ],
              },
              [
                _vm.hasRemoveDate
                  ? _c(
                      "div",
                      { staticClass: "effective-date" },
                      [
                        _c("label", { staticClass: "emphasis" }, [
                          _vm._v(_vm._s(_vm.$t("directory.removeDate"))),
                        ]),
                        _vm._v(" "),
                        _c("DatePicker", {
                          attrs: {
                            id: "directory-effective-date",
                            required: true,
                            calendarButton: true,
                            calendarButtonIcon: "fa fa-calendar",
                            disabledPicker: true,
                            value: _vm._f("formatDate")(
                              _vm.currentDirectory.removeDate
                            ),
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "effective-date" },
                  [
                    _c("label", { staticClass: "emphasis" }, [
                      _vm._v(_vm._s(_vm.$t("directory.effectiveDate"))),
                    ]),
                    _vm._v(" "),
                    _c("DatePicker", {
                      attrs: {
                        id: "directory-effective-date",
                        required: true,
                        calendarButton: true,
                        calendarButtonIcon: "fa fa-calendar",
                        disabledPicker: true,
                        value: _vm._f("formatDate")(
                          _vm.currentDirectory.effectiveDate
                        ),
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.isFloorDR
                  ? _c(
                      "div",
                      { staticClass: "floor" },
                      [
                        _c("label", { staticClass: "emphasis" }, [
                          _vm._v(_vm._s(_vm.$t("directory.label.floor"))),
                        ]),
                        _vm._v(" "),
                        _c("HKLSelect", {
                          attrs: {
                            options: [],
                            placeholder: "",
                            value: _vm.currentDirectory.floor,
                            required: true,
                            disabled: true,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "guideline",
                class: ["guideline", _vm.isFloorDR ? "floor-guideline" : ""],
              },
              [
                _c("div", { staticClass: "emphasis guideline-title" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "termsAndConditions." +
                          _vm.regionName +
                          ".directoryGuideLine.title"
                      )
                    )
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "ol",
                  _vm._l(
                    _vm.$t(
                      "termsAndConditions." +
                        _vm.regionName +
                        ".directoryGuideLine.content"
                    ),
                    function (item, key) {
                      return _c("li", { key: key }, [_vm._v(_vm._s(item))])
                    }
                  ),
                  0
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.latestRejectedHistory
            ? _c("div", { staticClass: "reject-history" }, [
                _c("label", { staticClass: "emphasis" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("directory.label.commentsFromOn", [
                        _vm.latestRejectedHistory.who,
                        _vm.latestRejectedHistory.when,
                      ])
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "reject-history__item" }, [
                  _c("div", { staticClass: "reject-comment" }, [
                    _c("pre", [
                      _vm._v(_vm._s(_vm.latestRejectedHistory.comment)),
                    ]),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          [
            _vm.companies.length
              ? _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "small-6 large-6 columns detail" },
                    [
                      _vm._l(_vm.companies, function (company, index) {
                        return [
                          _c("Company", {
                            key: company.id,
                            attrs: {
                              id: company.id,
                              index: index,
                              company: company,
                              type: _vm.currentDirectory.type,
                            },
                            on: {
                              "update:company": function ($event) {
                                company = $event
                              },
                            },
                          }),
                        ]
                      }),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "small-6 large-6 preview" },
                    [
                      _c("img", { attrs: { src: _vm.directoryImg } }),
                      _vm._v(" "),
                      _c("UploadDocs"),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }